import { useTranslation } from 'react-i18next';
import { ProjectLockup } from './ProjectLockup';

/** Visible session/bootstrap state. A slow mobile connection must never look
 * like a broken blank screen while the dashboard verifies its auth cookie. */
export function WorkspaceLoading() {
  const { t } = useTranslation();

  return (
    <main className="flex min-h-dvh items-center justify-center bg-canvas px-6" role="status" aria-live="polite">
      <div className="flex w-full max-w-sm flex-col items-center rounded-[1.75rem] border border-default bg-surface px-8 py-10 text-center shadow-sm">
        <ProjectLockup variant="hero" />
        <span className="mt-8 size-8 animate-spin rounded-full border-[3px] border-primary/20 border-t-primary motion-reduce:animate-none" aria-hidden="true" />
        <p className="mt-4 text-sm font-medium text-secondary">{t('loading')}</p>
      </div>
    </main>
  );
}
